import { TableCell, TableRow } from "@/components/_ui/table";
import { Row, RowData } from "@tanstack/react-table";

import { SubSectionData } from "../datatable-types";

interface DatatableListSubSectionRowProps<TData extends RowData> {
  row: Row<SubSectionData<TData>>;
}

export function DatatableListSubSectionRow<TData extends RowData>({ row }: DatatableListSubSectionRowProps<TData>) {
  const renderSubSectionHeader = row.original.column.renderSubSectionHeader;

  const count = row.subRows.length;

  if (!count) {
    return null;
  }

  if (!renderSubSectionHeader) {
    return null;
  }

  return (
    <TableRow
      key={row.id}
      data-state={row.getIsSelected() && "selected"}
      className="border-none text-xs"
      data-testid={"datatable-listsub-section-row"}
    >
      <TableCell colSpan={row.getVisibleCells().length} className="h-8 p-0">
        {renderSubSectionHeader(row.original, row)}
      </TableCell>
    </TableRow>
  );
}
